/**
 * The portal is served from BOTH the legacy `myluxedo.com` hosts and the current
 * canonical domain. On the legacy hosts we replace the login form with a
 * "we've moved" notice pointing at `VITE_PORTAL_URL`, so new sign-ins land on the
 * current domain instead of creating a session that only exists on the old one
 * (the two are different registrable domains, so cookies never cross).
 *
 * `connect.*` hosts are deliberately excluded: they serve the on-device Wi-Fi
 * setup flow, reached from a projector's own hotspot (see the
 * `connect.luxedo.com` redirect in PageRouter). A device owner sitting on that
 * hotspot has no route to the canonical domain, so the notice must never
 * replace it.
 */
const LEGACY_DOMAIN = "myluxedo.com"

/** True on the legacy portal hosts (`myluxedo.com` / `*.myluxedo.com`), except
 *  the `connect.*` device-setup hosts. */
export function isLegacyPortalHost(hostname: string = window.location.hostname): boolean {
	if (hostname.startsWith("connect.")) return false
	return hostname === LEGACY_DOMAIN || hostname.endsWith(`.${LEGACY_DOMAIN}`)
}

/**
 * Canonical portal URL, injected at BUILD time from `VITE_PORTAL_URL` (Vite
 * inlines `import.meta.env.*`, so this cannot be changed at runtime).
 * Empty when unconfigured — callers must omit the link rather than render a
 * broken one.
 */
export const CANONICAL_PORTAL_URL: string = import.meta.env.VITE_PORTAL_URL ?? ""
